/**
 * Created by Administrador on 30/10/2019.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('specialInvoiceReportService',specialInvoiceReportService);

    specialInvoiceReportService.$inject = ['$http', 'CONFIG','messageService'];

    function specialInvoiceReportService($http, CONFIG, messageService){

        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_REPORT + '/' + CONFIG.API + '/salesReports';

        var service = {
            getSpecialInvoiceReport: getSpecialInvoiceReport,
            getSpecialInvoiceReportPdf: getSpecialInvoiceReportPdf,
            getUpdateReserves: getUpdateReserves
        };

        return service;

        function getSpecialInvoiceReport(data){
            var params = '/specialSaleInvoice?fromDate='+data.fromDate+'&toDate=' + data.toDate;
            return $http.get(urlBase + params)
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findError('');
                });
        }

        function getSpecialInvoiceReportPdf(data){
            return $http.get(urlBase +'/specialSaleInvoice/pdf?fromDate='+data.fromDate + '&toDate=' + data.toDate,
                {responseType:'arraybuffer'})
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.registerError('');
                });
        }

        function getUpdateReserves(){
            return $http.get(urlBase + '/deletedReserveNoOperationalOrFull')
                .then(function(response){
                    messageService.registerUpdate('');
                    return response;
                }, function(error){
                    messageService.registerUpdateError('');
                });
        }
    }
})();
